<template>
  <div v-if="isEditable">
    <b-dropdown aria-role="list" position="is-top-left"
                @active-change="onChangeVisibilityMenu">
      <w-button size="small" :loading="loadingDownload || loadingDuplicate" data-test="menuWeetOpen"
                icon="dots-horizontal" slot="trigger"
                color="outlined"></w-button>
      <!-- DOWNLOAD WEET -->
      <div v-if="isEditable">
        <div v-if="isPremiumWorkspace">
          <b-dropdown-item data-test="menuWeetDownload" class="listItem" :disabled="isHidden"
                           @click="openExportOption()">
            <w-icon icon="download-outline" class="iconItem"/>
            <div class="labelMenuDownload">{{ $t('menuWeet.downloadMenu') }}</div>
          </b-dropdown-item>
        </div>
        <div v-else>
          <!-- NEED upgrade to have access to download -->
          <b-dropdown-item aria-role="listitem" class="listItem disabledDownload"
                           data-test="menuWeetDownload" @click="moveOrGoToPayment()">
            <w-icon icon="download-outline" class="iconItem"/>
            {{ $t('menuWeet.downloadMenu') }}
            <UpgradePlanTag class="upgradePlanTag"/>
          </b-dropdown-item>
        </div>
      </div>
      <!-- DUPPLICATE WEET -->
      <b-dropdown-item aria-role="listitem" v-if="isEditable" class="listItem"
                       @click="duplicateWeet" :disabled="isHidden"
                       data-test="menuWeetDuplicate">
        <w-icon icon="content-copy" class="iconItem"/>
        {{ $t('menuWeet.dupplicate') }}
      </b-dropdown-item>
      <!-- MOVE WEET -->
      <b-dropdown-item aria-role="listitem" v-if="canMoveWeet" class="listItem"
                       @click="moveWeetPanel=true" :disabled="isHidden  || !multipleWS"
                       data-test="menuWeetMove">
        <w-icon icon="folder-move-outline" class="iconItem"/>
        {{ $t('menuWeet.move') }}
      </b-dropdown-item>
      <!-- DELETE WEET -->
      <b-dropdown-item aria-role="listitem" v-if="isOwner" class="listItem" @click="deleteMyWeet"
                       data-test="menuWeetDelete">
        <w-icon icon="delete-outline" class="iconItem"/>
        {{ $t('menuWeet.delete') }}
      </b-dropdown-item>
      <!-- LEAVE WEET -->
      <b-dropdown-item aria-role="listitem" class="listItem" @click="leaveWeet" v-else-if="isCoowner"
                       data-test="menuWeetLeave">
        <w-icon icon="logout" class="iconItem"/>
        {{ $t('menuWeet.leave') }}
      </b-dropdown-item>
    </b-dropdown>

    <!-- Move panel -->
    <WorkspaceMovePanel :weet="weet" :active.sync="moveWeetPanel" :change-workspace-on-select="true"/>
    <!-- Download Panel -->
    <div v-if="isPremiumWorkspace">
      <DownloadOptionPanel :weet="weet" :active.sync="downloadPanelOption"/>
    </div>

    <WeetBlockerPlayer v-if="activateWeetBlocker" :isNewWeet="true" @closeWeetBlocker="closeWeetBlocker"/>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import {Weet} from '@/store/weet/weetModel';
import WButton from '@/components/wrapper/w-button.vue';
import {setActionEvent} from '@/utils/tracker';
import {ActionEvent} from '@/enum/TrackerEnum';
import {canEditThisWeet, isCoowner, isOwner} from '@/utils/weetUtil';
import store from '@/store';
import {DELETE_MY_WEET, DUPLICATE_MY_WEET} from '@/store/myWeet/myWeetAction';
import router from '@/router';
import {GET_WEET_SILENCE} from '@/store/weet/weetAction';
import WIcon from '@/components/wrapper/w-icon.vue';
import slugify from '@sindresorhus/slugify';
import {log} from '@/utils/log';
import {
  alertMessageWithConfirmation,
  confirmationDanger,
  inform
} from '@/utils/dialog';
import WToolTip from '@/components/wrapper/w-toolTip.vue';
import delay from 'delay';
import WorkspaceMovePanel from '@/components/workspace/WorkspaceMovePanel.vue';
import {
  canMoveWeetFromCurrentWorkspace,
  hasPaidWorkspace,
  isFreemiumQuotaReached,
  isWorkspaceInFreePlan
} from '@/utils/workspaceUtil';
import {PaymentPlanEnum, Workspace} from '@/store/workspace/workspaceModel';
import UpgradePlanTag from '@/components/upgradePlan/UpgradePlanTag.vue';
import DownloadOptionPanel from "@/components/download/DownloadOptionPanel.vue";
import {GET_WORKSPACE_WEET_COUNT} from '@/store/workspace/workspaceAction';
import WeetBlockerPlayer from '@/components/play/player/weetPlayerSubComponent/WeetBlockerPlayer.vue';
import {STORE_LINK_REDIRECT_AFTER_PAYMENT} from "@/store/persistedInformation/persistAction";

@Component(
    {
      components: {WeetBlockerPlayer, DownloadOptionPanel, UpgradePlanTag, WorkspaceMovePanel, WToolTip, WIcon, WButton}
    })
export default class MenuWeet extends Vue {
  @Prop() private weet!: Weet;
  private currentWeet: Weet | null = null;
  private loadingDownload: boolean = false;
  private loadingDuplicate: boolean = false;
  private moveWeetPanel: boolean = false;
  private downloadPanelOption: boolean = false;
  private activateWeetBlocker: boolean = false;

  get isEditable(): boolean {
    if (this.weet) {
      return canEditThisWeet(this.weet);
    } else {
      return false;
    }
  }

  get isOwner(): boolean {
    if (this.weet) {
      return isOwner(this.weet);
    } else {
      return false;
    }
  }

  get isCoowner(): boolean {
    if (this.weet) {
      return isCoowner(this.weet);
    } else {
      return false;
    }
  }
  get isHidden(): boolean {
    return this.weet.hidden;
  }

  get multipleWS(): boolean {
    return store.getters.getMyWorkspaces.length > 0;
  }

  get isExportable(): boolean {
    if (this.currentWeet) {
      return this.currentWeet.exportAivailable;
    } else {
      return this.weet.exportAivailable;
    }
  }

  get selectedWorkspaceID(): string {
    return store.getters.getSelectedWorkspace;
  }

  get canMoveWeet(): boolean {
    if (this.weet) {
      return this.isEditable && (this.weet.workspaces.length === 0 || canMoveWeetFromCurrentWorkspace());
    } else {
      return false;
    }
  }

  get isPremiumWorkspace(): boolean {
    // if (true) {
    //   return true;
    // }
    if (this.weet.workspaces.length > 0) {
      // the workspace is loaded when the weet is load (if available)
      const ws = store.getters.getWorkspace(this.weet.workspaces[0].workspaceID) as Workspace;
      if (ws) {
        return ws.plan !== PaymentPlanEnum.FREE;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  get isFreemiumQuotaReached(): boolean {
    return isWorkspaceInFreePlan() && isFreemiumQuotaReached();
  }

  private mounted() {
    this.currentWeet = this.weet;
  }

  private async onChangeVisibilityMenu(open) {
    if (open) {
      if (this.isEditable && this.isPremiumWorkspace) {
        if (!this.isExportable) {
          while (this.currentWeet && !this.currentWeet.exportAivailable) {
            this.currentWeet = await store.dispatch(GET_WEET_SILENCE, this.weet.weetID);
            await delay(2000);
          }
        }
      }
    }
  }


  private deleteMyWeet() {

    if (this.isEditable) {
      confirmationDanger(
          this.$t('deleteWeet.confirm.message').toString(),
          this.$t('deleteWeet.confirm.title').toString(),
          this.$t('deleteWeet.confirm.buttonConfirm').toString(),
      ).then(() => {
        setActionEvent(ActionEvent.player_button_delete, {weetID: this.weet.weetID});
        store.dispatch(DELETE_MY_WEET, this.weet).then(() => {
          router.push({name: 'Home'});
        });
      }).catch(() => {
        log.debug('Delete cancel');
      });
    }
  }

  private leaveWeet() {

    if (this.isCoowner) {
      confirmationDanger(
          this.$t('leaveWeet.confirm.message').toString(),
          this.$t('leaveWeet.confirm.title').toString(),
          this.$t('leaveWeet.confirm.buttonConfirm').toString(),
      ).then(() => {
        setActionEvent(ActionEvent.player_button_delete);
        store.dispatch(DELETE_MY_WEET, this.weet).then(() => {
          router.push({name: 'Home'});
        });
      }).catch(() => {
        log.debug('Delete cancel');
      });
    }
  }

  private duplicateWeet() {
    if (this.isFreemiumQuotaReached) {
      this.activateWeetBlocker = true;
    } else {
      setActionEvent(ActionEvent.thumb_button_duplicate);
      this.loadingDuplicate = true;
      store.dispatch(DUPLICATE_MY_WEET, this.weet.weetID)
          .then((cloneWeet: Weet) => {
            inform(this.$t('duplicateWeet.confirm').toString());
            // recompute the number of weet in the workspace
            store.dispatch(GET_WORKSPACE_WEET_COUNT);
            router.push({
              name: 'PreviewWeet',
              params: {
                weetID: cloneWeet.weetID,
                title: slugify(cloneWeet.title),
                message: this.$t('duplicateWeet.confirm').toString()
              },
            });
            this.loadingDuplicate = false;
          })
          .catch((err) => {
            log.error(err);
            this.loadingDuplicate = false;
          });
    }
  }


  private async moveOrGoToPayment() {
    // if i'm in PS
    // and i have a paid workspace
    // and i can move my weet
    if (!this.selectedWorkspaceID && hasPaidWorkspace() && this.canMoveWeet) {
      await alertMessageWithConfirmation(
          this.$t('menuWeet.downloadPs.move.description').toString(),
          this.$t('menuWeet.downloadPs.move.title').toString(),
      );
      this.moveWeetPanel = true;
    } else {
      store.dispatch(STORE_LINK_REDIRECT_AFTER_PAYMENT,document.location.href)
      router.push({name: 'MyWorkspacePayment'});
    }

  }

  private openExportOption() {
    if (this.isPremiumWorkspace) {
      this.downloadPanelOption = true;
    }
  }

  get titleDownload(): string {
    return slugify(this.weet.title);
  }

  private closeWeetBlocker() {
    this.activateWeetBlocker = false;
  }
}
</script>
<style lang="scss">
</style>
<style scoped lang="scss">

.listItem {
  display: flex;
  align-items: center;
  min-width: 210px;

  &.disabledDownload {
    color: #AAA;
    cursor: pointer;
  }

  .iconItem {
    margin-right: 8px;
  }

  &.red {
    color: var(--red);
  }

  .upgradePlanTag {
    position: absolute;
    right: 4px;
    top: 4px;
  }


}
</style>
